export const registeredFacets = [
  {
    attribute: "session.session_types.name",
    paramName: "sessionType",
    title: "Session Type",
    component: "CheckboxFilter",
    searchable: true,
  },
  {
    attribute: "session.owner_name",
    paramName: "createdBy",
    title: "Created By",
    component: "CheckboxFilter",
    searchable: true,
  },
  {
    attribute: "session.session_travel_details.arrival_city.city_ascii",
    paramName: "city",
    title: "City",
    component: "CheckboxFilter",
    searchable: true,
  },
  {
    attribute: "session.session_travel_details.arrival_city.country.name",
    paramName: "country",
    title: "Country",
    component: "CheckboxFilter",
    searchable: true,
  },
  {
    attribute: "session.terms.session",
    paramName: "terms",
    title: "Term",
    component: "CheckboxFilter",
    searchable: true,
  },
  {
    attribute: "session.session_hosting_institutions.entity.name",
    paramName: "hostInstitution",
    title: "Host Institution",
    component: "CheckboxFilter",
    searchable: true,
  },
  {
    attribute: "session.sponsoring_institutions.name",
    paramName: "sponsoringInstitution",
    title: "Sponsoring Institution",
    component: "CheckboxFilter",
    searchable: true,
  },
  {
    attribute: "session.academic_year",
    paramName: "academic_year",
    title: "Academic Year",
    component: "CheckboxFilter",
  },
  {
    attribute: "session.channel.name",
    paramName: "channel",
    title: "Channel",
    component: "CheckboxFilter",
  },
  {
    attribute: "session.status.name",
    paramName: "sessionStatusId",
    title: "Status",
    component: "CheckboxFilter",
  },
];
